import type { Toast } from "./types";

let toasts: Toast[] = [];
const listeners = new Set<() => void>();

function notify() {
  listeners.forEach((fn) => fn());
}

export function subscribe(fn: () => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function getSnapshot(): Toast[] {
  return toasts;
}

export function addToast(t: Toast): void {
  toasts = [...toasts, t];
  notify();
}

export function removeToast(id: string): void {
  toasts = toasts.filter((t) => t.id !== id);
  notify();
}

export function clearAllToasts(): void {
  toasts = [];
  notify();
}
